<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
* { margin: 0; padding: 0; box-sizing: border-box; }

html, body { width: 100%; height: 100%; overflow: hidden; }

#app {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%; height: 100%; overflow: hidden;
}

::-webkit-scrollbar { width: 6px; height: 6px; }
::-webkit-scrollbar-thumb { background: rgba(0,0,0,0.15); border-radius: 3px; }
::-webkit-scrollbar-thumb:hover { background: rgba(0,0,0,0.25); }
::-webkit-scrollbar-track { background: transparent; }

/* ===== Element UI Global Overrides ===== */

/* -- Buttons -- */
.el-button--primary {
  background: var(--color-primary) !important;
  border-color: var(--color-primary) !important;
}
.el-button--primary:hover { background: var(--color-primary-hover) !important; border-color: var(--color-primary-hover) !important; }
.el-button { border-radius: 6px !important; font-weight: 500 !important; font-size: 13px !important; }

/* -- Menu/Sidebar -- */
.el-menu { border-right: 1px solid var(--color-border) !important; }
.el-menu-item { font-size: 13px !important; height: 40px !important; line-height: 40px !important; color: var(--color-text-secondary) !important; }
.el-menu-item:hover { background: #F1F5F9 !important; color: var(--color-foreground) !important; }
.el-menu-item.is-active { color: var(--color-primary) !important; background: #F0FDFA !important; font-weight: 600 !important; }
.el-submenu__title { font-size: 13px !important; height: 40px !important; line-height: 40px !important; color: var(--color-text-secondary) !important; }

/* -- Table -- */
.el-table { border: none !important; font-size: 13px !important; }
.el-table th.el-table__cell { background: var(--color-muted) !important; color: var(--color-text-secondary) !important; font-size: 12px !important; font-weight: 600 !important; text-transform: uppercase; letter-spacing: 0.05em; padding: 10px 12px !important; border-bottom: 2px solid var(--color-border) !important; }
.el-table td.el-table__cell { padding: 10px 12px !important; border-bottom: 1px solid var(--color-muted) !important; }
.el-table tr:hover td { background: #F1F5F9 !important; }
.el-table--striped .el-table__body tr.el-table__row--striped td { background: var(--color-muted) !important; }

/* -- Card -- */
.el-card { border-radius: 8px !important; border: 1px solid var(--color-border) !important; box-shadow: 0 1px 2px rgba(0,0,0,0.04) !important; }
.el-card__header { padding: 16px 24px !important; border-bottom: 1px solid var(--color-border) !important; font-size: 16px !important; font-weight: 600 !important; color: var(--color-foreground) !important; }

/* -- Form -- */
.el-form-item__label { color: var(--color-text-secondary) !important; font-weight: 500 !important; font-size: 13px !important; }
.el-input__inner { border-radius: 6px !important; border-color: var(--color-border) !important; font-size: 13px !important; }
.el-input__inner:focus { border-color: var(--color-primary) !important; }
.el-select .el-input .el-select__caret { color: var(--color-text-muted) !important; }

/* -- Tags -- */
.el-tag { border: none !important; font-weight: 500 !important; font-size: 12px !important; border-radius: 4px !important; }

/* -- Dialog -- */
.el-dialog { border-radius: 12px !important; }
.el-dialog__header { padding: 20px 24px 0 !important; font-size: 16px !important; font-weight: 600 !important; }
.el-dialog__body { padding: 20px 24px !important; }

/* -- Pagination -- */
.el-pagination { margin-top: 16px; }

/* -- Divider -- */
.el-divider__text { color: var(--color-text-muted) !important; font-size: 12px !important; }

/* -- Tabs -- */
.el-tabs__item { font-size: 13px !important; }
.el-tabs__item.is-active { color: var(--color-primary) !important; }
.el-tabs__active-bar { background-color: var(--color-primary) !important; }

/* -- Checkbox -- */
.el-checkbox__input.is-checked .el-checkbox__inner { background-color: var(--color-primary) !important; border-color: var(--color-primary) !important; }
</style>
